module.exports = __webpack_public_path__ + "img/rd-refill-icon.95f60083.png";